import type { SVGProps } from 'react'
const SvgSyBuy = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g strokeLinejoin="round">
			<path
				fillRule="evenodd"
				d="M7.422 19.07c-.829 0-1.514.689-1.514 1.516S6.595 22.1 7.422 22.1s1.516-.686 1.516-1.514-.688-1.516-1.516-1.516m0 1.5c.015 0 .016 0 .016.016s0 .014-.016.014c-.017 0-.014.003-.014-.014s-.002-.016.014-.016m11.252-1.5c-.829 0-1.514.688-1.514 1.516s.687 1.514 1.514 1.514 1.515-.686 1.515-1.514-.687-1.516-1.515-1.516m0 1.5c.015 0 .015 0 .015.016s.002.014-.015.014-.014.002-.014-.014-.002-.016.014-.016"
				clipRule="evenodd"
				opacity={0.4}
			/>
			<path d="M2.877 2.512a.75.75 0 0 0-.865.611.75.75 0 0 0 .61.865l1.509.262.914 10.896a2.564 2.564 0 0 0 2.545 2.34h10.912a2.564 2.564 0 0 0 2.527-2.19l.95-6.556a2.107 2.107 0 0 0-2.07-2.39H5.812l-.235-2.803a.75.75 0 0 0-.621-.676zM5.939 7.85h13.97c.373 0 .639.305.585.675l-.95 6.557a1.046 1.046 0 0 1-1.042.904H7.59a1.04 1.04 0 0 1-1.049-.965v-.002z" />
			<path
				d="M14.125 10.045a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h2.773a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75z"
				opacity={0.4}
			/>
		</g>
	</svg>
)
export default SvgSyBuy
